<template>
  <Container>
    <template #header>
      <Text :weight="600" :height="130" align="left">
        {{ $t("TronTokenBalances | Title") }}
      </Text>
    </template>
    <template #body>
      <div class="token-table">
        <div
          v-for="(token, index) in tokenBalances"
          :key="index"
          class="token-table__row"
        >
          <div class="left">
            <span>+</span>
            {{ formatBalance(token.amount, token.decimals) }} {{ token.symbol }}
          </div>
          <div class="right">
            {{ getTokenTypeLabel(token.token_type) }}
          </div>
        </div>
      </div>
    </template>
  </Container>
</template>
<script setup lang="js">
import { Container, Text } from "@/shared/ui";
import { amount as formatBalance } from "@/shared/utils/format";

defineProps({
  tokenBalances: {
    type: Array,
    default: () => [],
  },
});

function getTokenTypeLabel(token_type) {
  switch (token_type) {
    case "tron_native":
      return "Main";
    case "tron_trc10":
      return "TRC-10";
    case "tron_trc20":
      return "TRC-20";
    default:
      return "";
  }
}
</script>
<style scoped lang="scss">
.token-table {
  width: 100%;

  &__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 14px;
    border-bottom: 1px solid var(--bg-3);
    font-size: 14px;
    line-height: 130%;

    @media (max-width: 768px) {
      padding: 10px 0;
    }

    .left {
      font-weight: 600;

      span {
        color: var(--success);
      }
    }

    .right {
      font-weight: 600;
      color: var(--light-950);
    }
  }
}
</style>
